export default defineNuxtPlugin(() => {
  const { recaptchaSitekey } = useRuntimeConfig().public;
  useHead({
    script: [
      {
        src: `https://www.google.com/recaptcha/api.js?render=${recaptchaSitekey}`
      }
    ]
  });
});